import Injector from 'vue-inject';
import Debug from '@/util/debug';
import * as constants from '@/util/constants';

const debug = Debug('service:ages');

export default class AgesService {
  constructor(aas) {
    this.adApiService = aas;
    this.ages = null;
  }

  loadAgesFromApi() {
    debug.info('loading from api');
    return this.adApiService.getAges()
          .catch((err) => {
            debug.error('error: %o', err);
            return [];
          })
          .then((ages) => {
            let agesComputed = ages.online;
            if (ages.online.length === 1) {
              agesComputed = [];
              for (let from = ages.online[0].from; from < ages.online[0].to; from += 1) {
                agesComputed.push({ from, to: from + 1 });
              }
            } else {
              agesComputed.map(a => {
                if (a.from === null) a.from = constants.AGE_BOUNDS_MIN;
                if (a.to === null) a.to = constants.AGE_BOUNDS_MAX;
                return a;
              });
            }
            agesComputed.online = agesComputed;
            agesComputed.offline = ages.offline;
            debug.info('success: %j', agesComputed.map(a => `${a.from}-${a.to}`));
            this.ages = agesComputed;
            return agesComputed;
          });
  }

  getAges() {
    if (this.ages === null) {
      return this.loadAgesFromApi();
    }

    return new Promise(resolve => resolve(this.ages));
  }

  getDefault() {
    return this.getAges()
      .then(ages => {
        if (ages.length) {
          return { from: ages[0].from, to: ages[ages.length - 1].to };
        }

        throw new Error('no target.age options');
      });
  }
}

Injector.service('agesService', ['adApiService'], AgesService);



// WEBPACK FOOTER //
// ./src/services/AgesService.js